import React, { useEffect, useState } from "react";
import { useItemConfigContext } from "../../hooks/useContext/useItemConfigContext";
import { useAuthContext } from "../../hooks/useContext/useAuthContext";
import ErrorBox from "../Shared/ErrorBox";
import {
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  // IconButton,
  MenuItem,
  Select,
  CircularProgress,
  Input,
  FormHelperText,
} from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import ImageContainer from "../Shared/ImageContainerBox";
import { useTranslation } from "../../hooks/useTranslation";
// import { Delete } from '@mui/icons-material';

const CenteredDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
});

const InputContainer = styled(Input)({
  padding: "6px 12px",
  margin: ".8rem",
});

const ItemConfigForm = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { dispatch } = useItemConfigContext();
  const { user } = useAuthContext();

  const translateSizeOption = (option) => {
    if (option === 'One Size') return t('oneSize');
    if (option === 'Large & Small') return t('largeAndSmall');
    return option;
  };

  const getSubcategoryKey = (subcategory) => {
    const keyMap = {
      "Main Plates": "mainPlates",
      "Snacks & Fries": "snacksAndFries",
      "Burgers & Kebab": "burgersAndKebab",
      "Soups": "soups",
      "Pierogi & Regional": "pierogiAndRegional",
      "Desserts": "desserts",
      "Sweets": "sweets",
      "Hot": "hot",
      "Cold": "cold",
      "Alcoholic": "alcoholic",
      "Shots": "shots",
    };
    return keyMap[subcategory] || subcategory;
  };
  const [itemName, setItemName] = useState("");
  const [itemPrice1, setItemPrice1] = useState("");
  const [itemPrice2, setItemPrice2] = useState("");
  const [itemIncludes, setItemIncludes] = useState("");
  let [itemAvailable, setItemAvailable] = useState("");
  const [itemType, setItemType] = useState("");
  const [itemSize, setItemSize] = useState("One Size");
  const [imageFile, setImageFile] = useState(null);
  const [itemPriceAmount, setItemPriceAmount] = useState(false);
  const itemTypeOptions = ["Food", "Grill", "Drink"];
  const itemSizeOptions = ["One Size", "Large & Small"];
  const itemAvailableOptions = ["No", "Yes"];
  const [error, setError] = useState(null);
  const [emptyFields, setEmptyFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemPrice1Error, setItemPrice1Error] = useState(null);
  const [itemPrice2Error, setItemPrice2Error] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [itemSubcategory, setItemSubcategory] = useState("");
  let newItemDetails;

  const subcategoryOptions = {
    Food: [
      "Main Plates",
      "Snacks & Fries",
      "Burgers & Kebab",
      "Soups",
      "Pierogi & Regional",
      "Desserts",
      "Sweets",
    ],
    Grill: [
      "Main Plates",
      "Snacks & Fries",
      "Burgers & Kebab",
      "Soups",
      "Pierogi & Regional",
      "Desserts",
      "Sweets",
    ],
    Drink: [
      "Hot",
      "Cold",
      "Alcoholic",
      "Shots",
    ],
  };

  const toggleForm = () => setExpanded(!expanded);

  //render large item price input field if item size is Large & Small
  useEffect(() => {
    if (itemSize === "Large & Small") {
      setItemPriceAmount(false);
    } else {
      setItemPriceAmount(true);
    }
  }, [itemSize]);

  useEffect(() => {
    // reset subcategory when changing main type
    setItemSubcategory("");
  }, [itemType]);

  //useEffect to check if itemPrice1 and itemPrice2 is a number
  useEffect(() => {
    if (isNaN(itemPrice1)) {
      setItemPrice1Error(t('pleaseEnterValidNumber'));
      setEmptyFields((prev) => (prev.includes("itemPrice1") ? prev : [...prev, "itemPrice1"]));
    } else {
      setItemPrice1Error(null);
      setEmptyFields((emptyFields) =>
        emptyFields.filter((field) => field !== "itemPrice1")
      );
    }
    if (isNaN(itemPrice2) && itemSize === "Large & Small") {
      setItemPrice2Error(t('pleaseEnterValidNumber'));
      setEmptyFields((prev) => (prev.includes("itemPrice2") ? prev : [...prev, "itemPrice2"]));
    } else {
      setItemPrice2Error(null);
      setEmptyFields((emptyFields) =>
        emptyFields.filter((field) => field !== "itemPrice2")
      );
    }
  }, [itemPrice1, itemPrice2, itemSize, t]);


//frontend error handling
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      setError(t('mustBeLoggedIn'));
      return;
    }
    let emptyFieldsClientSide = [];
    if (!itemName) {
      emptyFieldsClientSide.push("itemName");
      setError(t('pleaseSetName'));
    }
    if (!itemSize) {
      emptyFieldsClientSide.push("itemSize");
      setError(t('pleaseSelectItemSize'));
    }
    if (!itemPrice1) {
      emptyFieldsClientSide.push("itemPrice1");
      setError(t('pleaseSetPrice'));
    }
    if (itemSize === "Large & Small" && !itemPrice2) {
      emptyFieldsClientSide.push("itemPrice2");
      setError(t('pleaseSetLargeItemPrice'));
    }
    if (!itemType) {
      emptyFieldsClientSide.push("itemType");
      setError(t('pleaseSelectFoodOrDrinks'));
    }
    const resolvedSubcategory = itemType === "Grill" ? "All" : itemSubcategory;
    if (itemType !== "Grill" && !itemSubcategory) {
      emptyFieldsClientSide.push("itemSubcategory");
      setError(t('pleaseSelectSubcategory'));
    }
    if (!itemAvailable) {
      emptyFieldsClientSide.push("itemAvailable");
      setError(t('pleaseSelectAvailability'));
    }
    if (emptyFieldsClientSide.length > 0) {
      setEmptyFields(emptyFieldsClientSide);
      if (emptyFieldsClientSide.length > 1) {
        setError("Please fill in all fields");
      }
      return;
    }

    if (itemAvailable === "Yes") {
      itemAvailable = true;
    } else {    
      itemAvailable = false;
    }

    if (itemSize !== "One Size") {
      newItemDetails = [
        {itemPrice: parseFloat(itemPrice1), itemSize: "Small"},
        {itemPrice: parseFloat(itemPrice2), itemSize: "Large"}
      ];
    } else {
      newItemDetails = [
        {itemPrice: parseFloat(itemPrice1), itemSize: "One Size"}
      ];
    }
    setLoading(true);

    try{
      const data = new FormData();
      data.append('file', imageFile)
      data.append('itemName', itemName)
      data.append('itemType', itemType)
      data.append('itemSubcategory', resolvedSubcategory);
      data.append('itemDetails', JSON.stringify(newItemDetails))
      data.append('itemIncludes', itemIncludes)
      data.append('itemAvailable', itemAvailable)

      const response = await fetch(
        process.env.REACT_APP_SERVER_URL + "/api/itemconfigs",
        {
          method: "POST",
          body: data,
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
      });
      const json = await response.json();
      setLoading(false);

      if (!response.ok) {
        setError(json.error);
        setEmptyFields(json.emptyFieldsBackEnd);
        console.log(json.error);
      }
      if (response.ok) {
        setImageFile(null);
        setItemName("");
        setItemPrice1("");
        setItemPrice2("");
        setItemIncludes("");
        setItemSize("");
        setItemType("");
        setItemSubcategory("");
        setItemAvailable("");
        setError(null);
        setEmptyFields([]);
        dispatch({ type: "CREATE_ITEMCONFIG", payload: json });
      }
    } catch (error) {
      console.error(error);
      setError(t('errorOccurred'));
    }
  };


  return (
    <Box
      component="form"
      sx={{
        "& > :not(style)": {
          m: 1,
          width: "100%",
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "white",
        p: 2,
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        maxHeight: expanded ? "auto" : "200px",
        overflow: "hidden",
      }}
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <div style={{ display: "flex", justifyContent: "space-between", cursor: "pointer" }}>
        <Typography variant="h6" component="h3">
          {t('addNewItem')}
        </Typography>
      </div>

      {/* Button to expand the form if it is not expanded */}
      {!expanded && (
        <Button
          variant="contained"
          sx={{
            marginTop: "1rem",
            backgroundColor: theme.palette.primary.main,
            ":hover": { bgcolor: theme.palette.secondary.main },
          }}
          onClick={toggleForm}
        >
          {t('expandForm')}
        </Button>
      )}

      {expanded && (
        <>
        {imageFile ? (
          <ImageContainer
            itemImage={imageFile ? URL.createObjectURL(imageFile) : null}
            itemName={itemName}
          />
        ) : null}
        {/* <Box display="flex" alignItems="center"> */}
        <InputContainer
          type="file"
          onChange={(event) => {
            const file = event.target.files[0];
            if (file) {
              setImageFile(file);
            }
          }}
        />
        {/* {imageFile && 
          <IconButton
            sx={{
              color: theme.palette.component.componentBackground,
              backgroundColor: theme.palette.component.componentBackground,
              ":hover": { bgcolor: theme.palette.common.offWhite },
            }}
            size="large"
            aria-label="Delete"
            aria-haspopup="true"
            ariant="outlined"
            onClick={() => setImageFile(null)}
          >
          <Delete sx={{color: theme.palette.common.error}}/>
          </IconButton>
        }
        </Box> */}
        <TextField
          required={true}
          label={t('itemName')}
          type="text"
          onChange={(e) => setItemName(e.target.value)}
          value={itemName}
          error={emptyFields && emptyFields.includes("itemName")}
          sx={{ marginTop: "0.5rem" }}
        />
        <FormControl required={true} fullWidth variant="outlined" margin="normal">
          <InputLabel id="itemSize">{t('itemSize')}</InputLabel>
          <Select
            labelId="itemSize"
            id="itemSize"
            value={itemSize}
            onChange={(e) => setItemSize(e.target.value)}
            label={t('itemSize')}
            error={emptyFields && emptyFields.includes("itemSize")}
          >
            <MenuItem value="">
              <em>{t('itemSizeQuestion')}</em>
            </MenuItem>
            {itemSizeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {translateSizeOption(option)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          required={true}
          label={itemPriceAmount ? t('price') : t('priceOfSmallItem')}
          autoComplete="Price"
          type="currency"
          onChange={(e) => setItemPrice1(e.target.value)}
          value={itemPrice1}
          error={(emptyFields && emptyFields.includes("itemPrice1")) || Boolean(itemPrice1Error)}
          sx={{ marginTop: "0.5rem" }}
        />
        {itemPrice1Error && (
          <FormHelperText sx={{color: theme.palette.common.error}}>{itemPrice1Error}</FormHelperText>
        )}

        {!itemPriceAmount && (
        <TextField
          required={true}
          label={t('priceOfLargeItem')}
          autoComplete="Price of Large Item"
          type="currency"
          onChange={(e) => setItemPrice2(e.target.value)}
          value={itemPrice2}
          error={(emptyFields && emptyFields.includes("itemPrice2")) || Boolean(itemPrice2Error)}
          sx={{ marginTop: "0.5rem" }}
        />
        )}
        {itemPrice2Error && (
          <FormHelperText sx={{color: theme.palette.common.error}}>{itemPrice2Error}</FormHelperText>
        )}
        <TextField
          required={false}
          name="itemIncludes"
          id="itemIncludes"
          label={t('itemDetails')}
          autoComplete="Item Details"
          rows={4}
          multiline
          onChange={(e) => setItemIncludes(e.target.value)}
          value={itemIncludes}
          error={emptyFields && emptyFields.includes("itemIncludes")}
          sx={{ marginTop: "0.5rem" }}
        />
        <FormControl required={true} fullWidth variant="outlined" margin="normal">
          <InputLabel id="itemType">{t('itemType')}</InputLabel>
          <Select
            labelId="itemType"
            id="itemType"
            value={itemType}
            onChange={(e) => setItemType(e.target.value)}
            label={t('itemType')}
            error={emptyFields && emptyFields.includes("itemType")}
          >
            <MenuItem value="">
              <em>{t('itemTypeQuestion')}</em>
            </MenuItem>
            {itemTypeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {t(option.toLowerCase())}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {itemType !== "Grill" && (
          <FormControl
            required={true}
            fullWidth
            variant="outlined"
            margin="normal"
            disabled={!itemType} // disable until a main type is chosen
          >
            <InputLabel id="itemSubcategory">{t('subcategory')}</InputLabel>
            <Select
              labelId="itemSubcategory"
              id="itemSubcategory"
              value={itemSubcategory}
              onChange={(e) => setItemSubcategory(e.target.value)}
              label={t('subcategory')}
              error={emptyFields && emptyFields.includes("itemSubcategory")}
            >
              <MenuItem value="">
                <em>{itemType ? t('chooseSubcategory') : t('selectItemTypeFirst')}</em>
              </MenuItem>
              {itemType &&
                subcategoryOptions[itemType]?.map((option) => (
                  <MenuItem key={option} value={option}>
                    {t(getSubcategoryKey(option))}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )}
        <FormControl required={false} fullWidth variant="outlined" margin="normal">
          <InputLabel id="itemAvailable">{t('available')}</InputLabel>
          <Select
            labelId="itemAvailable"
            id="itemAvailable"
            value={itemAvailable}
            onChange={(e) => setItemAvailable(e.target.value)}
            label={t('available')}
            error={emptyFields && emptyFields.includes("itemAvailable")}
          >
            <MenuItem value="">
              <em>{t('available')}</em>
            </MenuItem>
            {itemAvailableOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option === "Yes" ? t('yes') : t('no')}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <CenteredDiv>{loading ? <CircularProgress /> : null}</CenteredDiv>
        {error && <ErrorBox error={error} color={"error"} />}
        <Button
          variant="contained"
          type="submit"
          sx={{
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            ":hover": { bgcolor: theme.palette.secondary.main},
            marginTop: "1rem",
          }}
        >
          {t('addItem')}
        </Button>
        </>
      )}
    </Box>
  );
};

export default ItemConfigForm;